import { selectCanDeleteProfiles } from '@/redux/selectors/authSelectors';
import { CustomerProfile } from '@/redux/slices/slice_types';
import React from 'react';
import axios from '../../_utils/axios';
import { getData } from '../../redux/slices/dataTableSlice';
import { Dialog } from '../_common';
import OverflowMenuItem from '../_common/OverflowMenu/OverflowMenuItem';
import PolarisIcon from '../_common/PolarisIcon';
import { useToast } from '../_common/Toast';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

type ProfileDeleteProps = {
  profile: CustomerProfile;
};

const ProfileDelete = ({ profile }: ProfileDeleteProps) => {
  const canDeleteProfiles = useAppSelector(selectCanDeleteProfiles);
  const dispatch = useAppDispatch();
  const { error, success } = useToast();
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleProfileDelete = () => {
    if (!profile?.id) return;
    axios
      .delete(`/core/profile_templates/${profile.id}/`)
      .then(() => {
        dispatch(getData());
        success('Profile deleted successfully.');
      })
      .catch((err) => {
        error(err?.data?.message || 'There was a problem deleting the profile.');
      })
      .finally(() => setDialogOpen(false));
  };

  if (!canDeleteProfiles) return null;

  return (
    <div>
      <OverflowMenuItem onClick={() => setDialogOpen(true)}>
        <PolarisIcon icon="delete" height={14} />
        Delete Profile
      </OverflowMenuItem>
      {dialogOpen && (
        <Dialog
          open
          title="Confirm Profile Permanent Deletion"
          submitText="Delete"
          onSubmit={handleProfileDelete}
          onCancel={() => setDialogOpen(false)}
        >
          Profile{' '}
          <strong>
            {'"'}
            {profile?.name}
            {'"'}
          </strong>{' '}
          will be permanently deleted. This action cannot be undone.
        </Dialog>
      )}
    </div>
  );
};

export default ProfileDelete;
